import { render } from "./SuccessAlert.vue?vue&type=template&id=1b4d9136&scoped=true"
import script from "./SuccessAlert.vue?vue&type=script&lang=js"
export * from "./SuccessAlert.vue?vue&type=script&lang=js"

import "./SuccessAlert.vue?vue&type=style&index=0&id=1b4d9136&lang=scss&scoped=true"
import "./SuccessAlert.vue?vue&type=style&index=1&id=1b4d9136&lang=scss"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4d9136"]])

export default __exports__